package de.oevbs.kunde.kundenportal2.model.services.mydata

import de.oevbs.businesspartner.bpcrmservice2.bankaccount.model.BankAccount
import de.oevbs.businesspartner.bpcrmservice2.bankaccount.model.iban
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.validation.Validation
import dev.fritz2.validation.validation

/**
 * Extension-Property, die eine [Validation] für das `BankAccount`-Model aus dem
 * bp-crm2 nachliefert.
 */
val BankAccount.Companion.validation: Validation<BankAccount, Unit, ComponentValidationMessage>
    get() = validation { inspector ->
        val ibanSubInspector = inspector.map(BankAccount.iban())
        addAll(Iban.validation(ibanSubInspector, Unit))
    }